import { render } from "./AuthorityDetail.vue?vue&type=template&id=d347c9ac"
import script from "./AuthorityDetail.vue?vue&type=script&lang=js"
export * from "./AuthorityDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__